import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineSearchPlusIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M15 10h-3V7a.9997.9997 0 0 0-1-1 1.0001 1.0001 0 0 0-1 1v3H7a1.0002 1.0002 0 0 0-.707 1.7071A.9997.9997 0 0 0 7 12h3v3a1.0001 1.0001 0 0 0 2 0v-3h3a.9997.9997 0 0 0 1-1 .9999.9999 0 0 0-1-1Zm6.71 10.29L18 16.61A9 9 0 1 0 16.61 18l3.68 3.68a.9989.9989 0 0 0 1.0946.2189.9966.9966 0 0 0 .3254-.2189.9999.9999 0 0 0 0-1.39ZM11 18a6.9997 6.9997 0 0 1-6.8655-8.3656A7 7 0 1 1 11 18Z"/>
  </SvgIcon>
}

export default LineSearchPlusIcon
